import { createBrowserRouter, RouterProvider } from "react-router-dom";
import CasePage from "./pages/Case";
import PencilandPaperPage from "./pages/PencilAndPaper";
import DeductionsPage from "./pages/Deductions";
import KPIsPage from "./pages/KPIs";
import BigRedButtonPage from "./pages/BigRedButton";
import RootLayout from "./pages/Root";
import { useState } from "react";
import arrow from "./Components/images/arrow.png";
import happy from "./Components/images/happy.png";
import sad from "./Components/images/sad.png";
import ConclusionPage from "./pages/Conclusion";
import * as dateMath from 'date-arithmetic'

const ordersExample = [
  {
    isOnTime: true,
    orderNr: 1000,
    width: 10,
    color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 1, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0,
    setupDur: 0
  },
  {
    isOnTime: true,
    orderNr: 1001,
    width: 14,
    color: <mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>Grün</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 2, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1002,
    width: 18,
    color: <mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>Violett</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 3, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1003,
    width: 22,
    color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 4, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1004,
    width: 26,
    color: <mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>Grün</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 1, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1005,
    width: 30,
    color: <mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>Violett</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 2, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1006,
    width: 34,
    color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 3, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1007,
    width: 17,
    color: <mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>Grün</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 4, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1008,
    width: 21,
    color: <mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>Violett</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 1, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
  {
    isOnTime: true,
    orderNr: 1009,
    width: 25,
    color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
    moveUp: "",
    dueDate: dateMath.add(new Date(), 2, "day").toLocaleDateString(),
    endTime: "",
    totalSetupDur: 1,
    colorSetupDur: 1,
    widthSetupDur: 1,
    score: 0,
    dueDateViolations: 0
  },
]

function App() {                 
  const currentDate = new Date()
  console.log(currentDate)
  console.log(currentDate.getDate())

  let date = dateMath.add(new Date(), 1, "day").toLocaleDateString()
  console.log(date)

  let length = ordersExample.length;

  function calc () {

    let widthHours, widthMinutes, colorHours, totalHours, endTimeH = 8, endTimeM = 0, endTimeDay = currentDate.getDate(), dueDateViolations = 0, totalSetupMin = 0, dummyDayCount = 0;
    for (let i=1; i<length; i++) {
        //calculate WidthSetupDuration
        ordersExample[0].widthSetupDur = "0:00";

        ordersExample[i].widthSetupDur = ordersExample[i].width - ordersExample[i-1].width;
        if (ordersExample[i].widthSetupDur < 0) {
            ordersExample[i].widthSetupDur *= -1;
        }
        ordersExample[i].widthSetupDur *= 10;
        widthHours = Math.floor(ordersExample[i].widthSetupDur / 60);
        widthMinutes = ordersExample[i].widthSetupDur % 60; 
        if (widthMinutes === 0) {
          ordersExample[i].widthSetupDur = widthHours + ":00";
        } else {
        ordersExample[i].widthSetupDur = widthHours + ":" + widthMinutes;
        }

        //calculate ColorSetupDuration
        ordersExample[0].colorSetupDur = "-";
        ordersExample[i].colorSetupDur = "-";
        colorHours = 0;
        if ((ordersExample[i-1].color.props.children === "Violett") && (ordersExample[i].color.props.children === "Blau")) {
            colorHours = 12;
            ordersExample[i].colorSetupDur = colorHours + ":00";
        }
        if ((ordersExample[i-1].color.props.children === "Violett") && (ordersExample[i].color.props.children === "Grün")) {
            colorHours = 4;
            ordersExample[i].colorSetupDur = colorHours + ":00";
        }
        if ((ordersExample[i-1].color.props.children === "Grün") && (ordersExample[i].color.props.children === "Blau")) {
            colorHours = 8;
            ordersExample[i].colorSetupDur = colorHours + ":00";
        }

        //calculate TotalSetupDuration
        ordersExample[0].totalSetupDur = "0:00";
        totalHours = widthHours + colorHours;
        ordersExample[i].totalSetupDur = totalHours + ":" + widthMinutes;
        if (widthMinutes === 0) {
          ordersExample[i].totalSetupDur = totalHours + ":00"
        }

        totalSetupMin = totalHours * 60 + widthMinutes + totalSetupMin;//for Score
      

        //calculate EndTime
        ordersExample[0].endTime = (new Date()).toLocaleDateString() + " 8:00"; 
        endTimeM += widthMinutes;
        if (endTimeM >= 60) {
          endTimeH += 1;
          endTimeM -= 60;
        }

        endTimeH = endTimeH + totalHours + 8;
        if (endTimeH > 24) {
          endTimeDay += 1;
          dummyDayCount += 1; 
          endTimeH -= 24;
        }
        
        if (endTimeM === 0) {
          ordersExample[i].endTime = `${dateMath.add(new Date(), dummyDayCount, "day").getDate()}.${dateMath.add(new Date(), dummyDayCount, "day").getMonth() + 1}.${dateMath.add(new Date(), dummyDayCount, "day").getFullYear()} `  + endTimeH + ":00";
        } else {
          ordersExample[i].endTime = `${dateMath.add(new Date(), dummyDayCount, "day").getDate()}.${dateMath.add(new Date(), dummyDayCount, "day").getMonth() + 1}.${dateMath.add(new Date(), dummyDayCount, "day").getFullYear()} ` + endTimeH + ":" + endTimeM;
        }

        //IsOnTime
        let dummyDay;
        if (ordersExample[i].dueDate === dateMath.add(new Date(), 1, "day").toLocaleDateString()) {
          dummyDay = dateMath.add(new Date(), 1, "day").getDate();
        }
        if (ordersExample[i].dueDate === dateMath.add(new Date(), 2, "day").toLocaleDateString()) {
          dummyDay = dateMath.add(new Date(), 2, "day").getDate();
        }
        if (ordersExample[i].dueDate === dateMath.add(new Date(), 3, "day").toLocaleDateString()) {
          dummyDay = dateMath.add(new Date(), 3, "day").getDate();
        }
        if (ordersExample[i].dueDate === dateMath.add(new Date(), 4, "day").toLocaleDateString()) {
          dummyDay = dateMath.add(new Date(), 4, "day").getDate();
        }
        ordersExample[0].isOnTime = <img src={happy} width={25} height={25} alt="yes"/>;
        if (dummyDay >= endTimeDay) {
          ordersExample[i].isOnTime = true;
          ordersExample[i].isOnTime = <img src={happy} width={25} height={25} alt="yes" />;
        } else {
          ordersExample[i].isOnTime = false;
          dueDateViolations += 1;
        }
          //moveUp
        ordersExample[0].moveUp = "";
        if (ordersExample[i].isOnTime === false) {
          ordersExample[i].isOnTime = <img src={sad} width={25} height={25} alt="no"/>;
          ordersExample[i].moveUp =<img src={arrow} width={25} height={25} alt="up"/>;
        } else {
          ordersExample[i].moveUp = "";
        }

        ordersExample.score = totalSetupMin + dueDateViolations * 1000;
        ordersExample.dueDateViolations = dueDateViolations;
        ordersExample.setupDur = totalSetupMin / 60;

    }
  }
  const [orders, setOrders] = useState(ordersExample);

  //PenAndPaperStats
  const [penAndPaperScore, setPenAndPaperScore] = useState();
  const [penAndPaperSeconds, setPenAndPaperSeconds] = useState();
  const [penAndPaperMinutes, setPenAndPaperMinutes] = useState();
  function penAndPaperStatsHandler (score, seconds, minutes) {
    setPenAndPaperScore(score);
    setPenAndPaperSeconds(seconds);
    setPenAndPaperMinutes(minutes);
  }

  //DeductionStats
  const [deductionsScore, setDeductionsScore] = useState();
  const [deductionsSeconds, setDeductiionsSeconds] = useState();
  const [deductionsMinutes, setDeductionsMinutes] = useState();
  function deductionsStatsHandler (score, seconds, minutes) {
    setDeductionsScore(score);
    setDeductiionsSeconds(seconds);
    setDeductionsMinutes(minutes);
  }

  //KPIsStats
  const [kpisScore, setKpisScore] = useState();
  const [kpisSeconds, setKpisSeconds] = useState();
  const [kpisMinutes, setKpisMinutes] = useState();
  function kpisStatsHandler (score, seconds, minutes) {
    setKpisScore(score);
    setKpisSeconds(seconds);
    setKpisMinutes(minutes);
  }

  //isMobile
  const [isMobile, setIsMobile] = useState("");
  window.onload = windowSizeHandler;
  window.onresize = windowSizeHandler;
  function windowSizeHandler () {
    let windowWidth = window.innerWidth;
    if (windowWidth <= 900) {
      setIsMobile(true);
    } else {
      setIsMobile(false)
    }
  }

  const router = createBrowserRouter([
    {
      path: "/", 
      element: <RootLayout isMobile={isMobile}/>,
      children: [
        {index: true, element: <CasePage orders={orders} />},
        {path: "/1", element: <PencilandPaperPage orders={orders} calc={calc} penAndPaperStatsHandler={penAndPaperStatsHandler} isMobile={isMobile} />},
        {path: "/2", element: <DeductionsPage orders={orders} calc={calc} deductionsStatsHandler={deductionsStatsHandler} isMobile={isMobile} />},
        {path: "/3", element: <KPIsPage orders={orders} calc={calc} kpisStatsHandler={kpisStatsHandler} isMobile={isMobile}/>},
        {path: "/4", element: <BigRedButtonPage orders={orders}  calc={calc} isMobile={isMobile}/>},
        {path: "/5", element: <ConclusionPage penAndPaperScore={penAndPaperScore} penAndPaperSeconds={penAndPaperSeconds} penAndPaperMinutes={penAndPaperMinutes} deductionsScore={deductionsScore} deductionsSeconds={deductionsSeconds} deductionsMinutes={deductionsMinutes} kpisScore={kpisScore} kpisSeconds={kpisSeconds} kpisMinutes={kpisMinutes} />}
      ]
    }
  ]);

  return (
      <RouterProvider router={router} />
  );
}

export default App;
